import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=3e37703b"
import script from "./MessageAlert.vue?vue&type=script&lang=ts"
export * from "./MessageAlert.vue?vue&type=script&lang=ts"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=3e37703b&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports